<template>
  <form class="questionnaire_form">
    <div class="form-wrap">
      <div
        v-for="(item, i) in questions"
        :key="'question' + i"
        class="form-group form-group-confirm">
        <div class="form-label">
          <label
            class="control-label">
            {{ `Q${i+1}` }} {{ item.title }}
          </label>
        </div>
        <div class="form-item">
          <span
            v-if="item.type==='checkbox'"
            class="form-item-confirm-text">
            <span
              v-for="(answer, n) in answers[i]"
              :key="'answer' + n"
              class="multiple_selection">
              {{ answer }}
            </span>
          </span>
          <span
            v-else-if="item.type==='textarea'"
            class="form-item-confirm-text form-item-confirm-textarea">
            {{ answers[i] }}
          </span>
          <span
            v-else
            class="form-item-confirm-text">
            {{ answers[i] }}
          </span>
          <div
            v-if="item.other && others[i]!==''"
            class="form-item-confirm-text">
            {{ item.other_title?item.other_title:'その他' }}：{{ others[i] }}
          </div>
        </div>
      </div>
    </div>

    <div class="c-btn-wrap">
      <a
        class="c-btn"
        @click.prevent="onSendClicked">
        送信する
        <span class="c-btn__icon-arrow">
        </span>
      </a>
      <a
        class="c-btn c-btn--back c-btn--back-left"
        @click.prevent="onChangeClicked">
        変更する
        <span class="c-btn__icon-arrow c-btn__icon-arrow--left">
        </span>
      </a>
    </div>
  </form>
</template>

<script>
export default {
  name: 'SurveyConfirm',
  props: {
    questions: {
      type: Array,
      required: true,
    },
    answers: {
      type: Array,
      required: true,
    },
    others: {
      type: Array,
      required: true,
    },
  },
  methods: {
    onChangeClicked() {
      this.$emit('change-clicked')
    },
    onSendClicked() {
      this.$emit('send-clicked')
    },
  },
}
</script>

<style scoped>
.form-item-confirm-textarea {
  white-space: pre-line;
  word-break: break-all;
}
</style>
